import React from 'react'
import Image from 'components/image'
import { InfoButton } from 'components/buttons'
import { numberToCurrency } from 'lib/money'
import { FREE_SHIPPING_THRESHOLD } from 'shared/constants'
import { reservationsPath } from 'lib/urls'
import { track, useTracking } from 'lib/analytics'

export const BabylistOffer = ({
  price,
  regItem,
  onClick,
  inCart,
  registryFirstNames,
}) => {
  const { isAvailableOnBabylist, offers } = regItem
  const hasAdditionalOffers = offers.length > 1
  const tracker = useTracking()

  function handleAddToCart(e) {
    if (onClick) {
      onClick(e)
    }
    tracker.trackEvent({
      event: track.registryProductOfferClicked,
      store: 'Babylist',
    })
  }
  return (
    <div>
      <div className="flex">
        <div>
          <Image
            src="//res.cloudinary.com/babylist/image/upload/v1631884941/bl_store_icon_o8u8vu.png"
            width={44}
          />
        </div>
        <div className="flex-grow col ptm plm">
          <div className="flex">
            <div className="text-bold h5 flex grow mbn">Babylist Shop</div>
            <div className="text-bold h5 mbn">{numberToCurrency(price)}</div>
          </div>
        </div>
      </div>
      <div className="xsmall mts lh-lg">
        <div>Free shipping on orders ${FREE_SHIPPING_THRESHOLD}+*</div>
        <div>Free returns for {registryFirstNames}.</div>
      </div>
      <div className={hasAdditionalOffers && 'pbl'}>
        {inCart ? (
          <InfoButton
            href={reservationsPath}
            pill
            block
            empty
            className="mtm pam"
          >
            In Cart
          </InfoButton>
        ) : (
          <>
            <InfoButton
              pill
              block
              className="mtm pam"
              onClick={handleAddToCart}
              disabled={!isAvailableOnBabylist}
            >
              Add to Cart
            </InfoButton>
            {!isAvailableOnBabylist && (
              <small className="block text-center xsmall pam">
                Out of Stock
              </small>
            )}
          </>
        )}
      </div>
    </div>
  )
}

BabylistOffer.defaultProps = {
  registryFirstNames: 'the family',
}
